const CONFIG = {
    PublicUrl: process.env.PUBLIC_URL ?? '',
    Name: process.env.NAME ?? 'Sourire',
    Version: process.env.VERSION ?? '3.5.01',
    ChatUpdateInterval: parseInt(process.env.CHAT_UPDATED_INTERVAL ?? '15000', 10),
    TokenRenewInterval: parseInt(process.env.TOKEN_RENEW_INTERVAL ?? '15000', 10),
    ApiBaseUrl: process.env.API_BASE_URL ?? 'https://api.sourire.fednuzzo.it'
};

export default CONFIG;